import React, { PureComponent } from 'react'
import {
  Paper,
  Table,
  TableCell,
  TableRow,
  Grid,
  TableBody,
  TableHead,
  TableSortLabel,
} from '@material-ui/core'

import { CreateBusForm, BusTableRow } from './components'

export class BusesBase extends PureComponent {
  createSortHandler = property => e => this.props.requestSortHandler(e, property)

  renderBus = ({ id, label, qty, company, brand }) => {
    const { classes, setBus, deleteBus } = this.props

    return (
      <BusTableRow
        id={id}
        key={id}
        qty={qty}
        label={label}
        setBus={setBus}
        company={company}
        brand={brand}
        classes={classes}
        deleteBus={deleteBus}
      />
    )
  }

  getSorting(order, orderBy) {
    return order === 'desc'
      ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
      : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
  }

  render() {
    const { buses, order, orderBy, classes } = this.props

    return (
      <Grid
        container
        spacing={8}
        component={Paper}
        direction='column'
      >

        <Grid item>
          <CreateBusForm />
        </Grid>

        <Grid item xs>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding='dense'>
                  <TableSortLabel
                    active={orderBy === 'brand'}
                    onClick={this.createSortHandler('brand')}
                    direction={order.length > 0 ? order : 'asc'}
                  >
                    Виробник
                  </TableSortLabel>
                </TableCell>

                <TableCell className={classes.tableCell} padding='none'>
                  <TableSortLabel
                    active={orderBy === 'label'}
                    onClick={this.createSortHandler('label')}
                    direction={order.length > 0 ? order : 'asc'}
                  >
                    Назва
                  </TableSortLabel>
                </TableCell>

                <TableCell className={classes.tableCell} padding='dense'>
                  <TableSortLabel
                    active={orderBy === 'qty'}
                    onClick={this.createSortHandler('qty')}
                    direction={order.length > 0 ? order : 'asc'}
                  >
                    кть
                  </TableSortLabel>
                </TableCell>

                <TableCell padding='checkbox' />
              </TableRow>
            </TableHead>

            <TableBody>
              {buses.sort(this.getSorting(order, orderBy)).map(this.renderBus)}
            </TableBody>
          </Table>
        </Grid>

      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Buses/Buses.js